// extracted by mini-css-extract-plugin
export default {"h2Text":"textL_h2Text__5bRmx"};